import { FetchContext } from '../fetch-context';
import { QuestionnaireProgress } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const updateQuestionnaireProgress: (
  fetchContext: FetchContext,
  questionnaireId: number, 
  questionnaireProgress: QuestionnaireProgress,
  accessToken?: string,
) => Promise<void> = (fetchContext, questionnaireId, questionnaireProgress, accessToken) => {
  return fetch(`${fetchContext.baseUrl}/api/questionnaires/${questionnaireId}/progress`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(questionnaireProgress),
  }).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update questionnaire progress'));
};
